export const DEFAULT_MIN_YEAR_FOR_YEAR_SELECT = 2018;